import React, { useState } from "react";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import SocialMedia01 from "@/components/SocialMedia/components/SocialMedia01";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EContentType from "@/cms/enums/EContentType";
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";


const MNPG007 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG007.rendered", props);

    const [siteSettings] = useState(props.templates?.find((item) => item.contentType === EContentType.SITE_SETTING && item.parentId === props.template?.id));
    const [aboutUs] = useState(props.templates?.find((item) => item.contentType !== EContentType.SITE_SETTING && item.parentId === props.template?.id));
    const [siteName] = useState(outerNameDescriptionLanguageVersion(siteSettings?.languageVersions));
    const [aboutUsLanguageVersion] = useState(outerNameDescriptionLanguageVersion(aboutUs?.languageVersions));

    if ( !props.template ) return null;

    return (
        <div className="col-lg-4 col-sm-6">
            <div
                className="single-footer-widget"
                data-aos="fade-in"
                data-aos-duration="1000"
                data-aos-delay="100"
            >
                <div className="logo">
                    <RMDRImage
                        resourceType={EResourceType.LOGO_WITH_BOTTOM_TEXT} 
                        resources={siteSettings?.resources} 
                        sizeType={ESizeType.X06}
                        alt={siteName?.name} 
                        title={siteName?.name}
                    />
                </div>

                <RMDRComponentSanitizer languageVersion={aboutUsLanguageVersion} variant="div" valueExpr="value" />

                <SocialMedia01 
                    payload={siteSettings?.languageVersions}
                    className="social-links"
                />
            </div>
        </div>
    )
}

const Component = React.memo(MNPG007, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG007.memo", { prevProps, nextProps });
    return true;
});

export default Component;
